import { render, staticRenderFns } from "./DevPortal.vue?vue&type=template&id=874f2d38&"
import script from "./DevPortal.vue?vue&type=script&lang=js&"
export * from "./DevPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports